/**
 * 缓存说明:工单相关的
 */
import vm from '@/cache/storeTools.js'
import flowApi from '@/components/api/order/flowApi.js'
import orderApi from '@/components/api/order/orderApi.js'
import itemApi from '@/components/api/systemApi.js'
import userStore from '@/cache/userStore.js'
var basestate = {
	flowTree: undefined, //工作流模板
	order: {},
	adminOrder: {},
	finishOrder: {}, //已完成
	orderIdToInfo: {}, //工单信息
	flowNodes: {}, //工作流下的所有节点
	itemTemplate: undefined, //步骤模板
	nowOrder: undefined, //当前选中的工单
	copyOrderId: undefined,
	orderTypeList: [{
		name: '普通工单',
		value: 'Order'
	}, {
		name: '系统发布',
		value: 'CycleOrder'
	}],
	cycleTypeList: [{
		name: '每天生成',
		value: 'day'
	}, {
		name: '每周生成',
		value: 'week'
	}, {
		name: '每月生成',
		value: 'month'
	}, {
		name: '每年生成',
		value: 'year'
	}],
	realStateList: [{
			name: '未开始',
			value: 'NotStarted'
		},
		{
			name: '未响应',
			value: 'NotResponse'
		},
		{
			name: '处理中',
			value: 'Doing'
		},
		{
			name: '超时未完成',
			value: 'OvertimeNotDone'
		}, {
			name: '暂停中',
			value: 'Stopping'
		}
	],
	historyStateList: [{
			name: '中止完成',
			value: 'BreakOff'
		},
		{
			name: '已完成',
			value: 'Done'
		},
		{
			name: '超时完成',
			value: 'OvertimeDone'
		}
	],
	stateList: [{
			name: '未开始',
			value: 'NotStarted'
		},
		{
			name: '未响应',
			value: 'NotResponse'
		},
		{
			name: '处理中',
			value: 'Doing'
		},
		{
			name: '超时未完成',
			value: 'OvertimeNotDone'
		}, {
			name: '暂停中',
			value: 'Stopping'
		}, {
			name: '中止完成',
			value: 'BreakOff'
		},
		{
			name: '已完成',
			value: 'Done'
		},
		{
			name: '超时完成',
			value: 'OvertimeDone'
		},
		{
			name: '回收站',
			value: 'Deleted'
		}
	],
	defaultStateList: ['NotStarted', 'NotResponse', 'Doing', 'Done', 'OvertimeNotDone', 'OvertimeDone'],
	//模板列表，一次性获取全部
	orderTemplateList: undefined,
}

function getType(pageData) {
	return pageData.type
}

function getKey(pageData) {
	var Keys = Object.keys(pageData)
	var key = ''
	Keys.forEach((data, i) => {
		if(i != 0) {
			key += '_'
		}
		key += pageData[data]
	})
	return key
}
var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getItemTemplateTree(state, getters) {
			if(state.itemTemplate == undefined) {
				store.commit('getItemTemplateTree')
			}
			return state.itemTemplate
		},
		findNodesWithFlowId(state, getters) {
			return(flowId) => {
				if(state.flowNodes[flowId] == undefined) {
					store.commit('findNodesWithFlowId', flowId)
					return []
				}
				return state.flowNodes[flowId]
			}
		},
		getStateNameByStatus(state) {
			return status => {
				var item = state.stateList.find(it => {
					return it.value == status
				})
				if(item != undefined) {
					return item.name
				}
			}
		},
		searchByTypeForAdmin(state, getters) {
			return(type, userId, index, pageSize, statusString, userList,
				beginTime, endTime, orderTypeString, priorityString) => {
				var pageData = {
					type,
					userId,
					index,
					pageSize,
					statusString,
					userList,
					beginTime,
					endTime,
					orderTypeString,
					priorityString
				}
				if(state.adminOrder[getKey(pageData)] == undefined) {
					store.commit('searchByTypeForAdmin', pageData)
				}
				return state.adminOrder[getKey(pageData)]
			}
		},
		searchByType(state, getters) {
			return(type, userId, index, pageSize, statusString, userList,
				beginTime, endTime, orderTypeString, priorityString) => {
				var pageData = {
					type,
					userId,
					index,
					pageSize,
					statusString,
					userList,
					beginTime,
					endTime,
					orderTypeString,
					priorityString
				}
				if(state.order[getKey(pageData)] == undefined) {
					store.commit('searchByType', pageData)
				}
				return state.order[getKey(pageData)]
			}
		},
		getFlowTree(state, getters) {
			if(state.flowTree == undefined) {
				store.commit('getFlowTree')
				return []
			}
			return state.flowTree
		},
		getOrderInfoById(state, getters) {
			return orderId => {
				if(state.orderIdToInfo[orderId] == undefined) {
					store.commit('getOrderInfoById', orderId)
					return {}
				}
				return state.orderIdToInfo[orderId]
			}
		},
		getOrderTemplateList(state, getters) {
			return(status) => {
				if(state.orderTemplateList == undefined) {
					store.commit('getOrderTemplateList')
					return []
				}
				var baseList = state.orderTemplateList
				if(status != undefined) {
					baseList = baseList.filter(item => {
						return item.status == status
					})
				}
				return baseList
			}
		}

	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		/**
		 * 获取一个流下所有节点
		 */
		findNodesWithFlowId(state, flowId) {
			flowApi.findNodes(flowId, respon => {
				vm.Vue.set(state.flowNodes, flowId, respon)
			})
		},
		getItemTemplateTree(state) {
			itemApi.getItemTemplateTree(respon => {
				vm.Vue.set(state, 'itemTemplate', respon)
			})
		},
		getFlowTree(state) {
			flowApi.getFlowTree(respon => {
				vm.Vue.set(state, 'flowTree', respon)
			})
		},
		searchByTypeForAdmin(state, pageData) {
			orderApi.searchByTypeForAdmin(pageData.type, pageData.userId, pageData.index, pageData.pageSize,
				pageData.statusString, pageData.userList, pageData.beginTime, pageData.endTime, pageData.orderTypeString,
				pageData.priorityString, respon => {
					vm.Vue.set(state.adminOrder, getKey(pageData), respon)
				})
		},
		searchByType(state, pageData) {
			//type, userId, pageIndex, pageSize, statusString, userList,
			//beginTime, endTime, orderTypeString, priorityString
			orderApi.searchByType(pageData.type, pageData.userId, pageData.index, pageData.pageSize,
				pageData.statusString, pageData.userList, pageData.beginTime, pageData.endTime, pageData.orderTypeString,
				pageData.priorityString, respon => {
					vm.Vue.set(state.order, getKey(pageData), respon)
				})
		},
		getOrderInfoById(state, orderId) {
			orderApi.getOrderInfoById(orderId, res => {
				vm.Vue.set(state.orderIdToInfo, orderId, res)
			}, res => {
				log(res)
			})
		},
		getOrderTemplateList(state) {
			orderApi.searchByType(1, 200, undefined, 'OrderTemplate', undefined, undefined,
				userStore.state.nowUserInfo.userId, undefined, undefined, undefined, undefined, undefined, respon => {
					vm.Vue.set(state, 'orderTemplateList', respon.dataList)
				})
		},
		setNowOrder(state, order) {
			state.nowOrder = order
		},
		setCopyOrderId(state, orderId) {
			state.copyOrderId = orderId
		}
	}
})

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */